export default [
  {
    path: '/invoice/index',
    component: () => import('@/views/invoice/index.vue'),
    name: 'invoice.index',
    meta: {
      title: '开具发票',
    },
    hidden: true,
  },
  {
    path: '/invoice/detail',
    component: () => import('@/views/invoice/detail.vue'),
    name: 'invoice.detail',
    meta: {
      title: '发票详情',
    },
    hidden: true,
  },
  {
    path: '/invoice/record',
    component: () => import('@/views/invoice/record.vue'),
    name: 'invoice.record',
    meta: {
      title: '开票记录',
    },
    hidden: true,
  },
  {
    path: '/invoice/ticketheader',
    component: () => import('@/views/invoice/ticketHeader.vue'),
    name: 'invoice.ticketheader',
    meta: {
      title: '发票抬头',
    },
    hidden: true,
  },
  {
    path: '/invoice/myticketheader',
    component: () => import('@/views/invoice/myTicketHeader.vue'),
    name: 'invoice.myticketheader',
    meta: {
      title: '我的发票抬头',
    },
    hidden: true,
  },
];
